import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Reservation, ReservationSms, Result } from './reservation.model';

@Injectable()
export class ReservationApiService {
	private readonly API_URL = environment.apiUrl;
	private readonly httpClient = inject(HttpClient);

	updateReservation(reservationId: number, payload: Partial<Reservation>): Observable<Reservation> {
		return this.httpClient.patch<Reservation>(`${this.API_URL}/reservation/${reservationId}/`, payload);
	}

	getReservationSms(reservationId: number): Observable<ReservationSms[]> {
		return this.httpClient
			.get<Result<ReservationSms>>(`${this.API_URL}/reservation/${reservationId}/sms/`)
			.pipe(map((result) => result?.results));
	}
}
